/**
 * @generated SignedSource<<8cbc406eb3055a2eb602cf80f178008d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkDeletedValue_pixQrCode$data = {
  readonly id: string;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentLinkDeletedValue_pixQrCode";
};
export type PaymentLinkDeletedValue_pixQrCode$key = {
  readonly " $data"?: PaymentLinkDeletedValue_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkDeletedValue_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkDeletedValue_pixQrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "fdebec5d35b3de86154817d7995d3767";

export default node;
